import { useEffect, useState } from 'react';
import CrudPage from './shared/CrudPage';
import { adminGet, adminPost, adminPut, adminDelete, getLenguajes } from '../../api/adminClient';

export default function AdminCarrusel() {
  const [lenguajeOpts, setLenguajeOpts] = useState([]);

  useEffect(() => {
    getLenguajes()
      .then((rows) => setLenguajeOpts(rows.map((l) => ({ value: l.ID, label: l.Descripcion }))))
      .catch(() => {});
  }, []);

  return (
    <CrudPage
      title="Imágenes del carrusel"
      idKey="ID"
      columns={[
        { key: 'ID',            label: 'ID' },
        { key: 'lenguaje',      label: 'Acceso' },
        { key: 'Titulos',       label: 'Título', primary: true },
        { key: 'Orden',         label: 'Orden' },
        { key: 'mostrar_inicio',label: 'Inicio', render: (v) => v ? '✓' : '' },
        { key: 'Baja',          label: 'Baja',   render: (v) => v ? 'Sí' : 'No' },
      ]}
      fields={[
        { key: 'id_lenguaje',   label: 'Acceso',      type: 'select', options: lenguajeOpts, required: true },
        { key: 'Titulos',       label: 'Título',         required: true },
        { key: 'Descripcion',   label: 'Descripción',    type: 'textarea' },
        { key: 'Link',          label: 'URL del link' },
        { key: 'Leyendalink',   label: 'Leyenda del link' },
        { key: 'Orden',         label: 'Orden',          defaultValue: '0' },
        { key: 'mostrar_inicio',label: 'Mostrar en inicio', type: 'checkbox' },
        { key: 'Baja',          label: 'Baja',           type: 'checkbox' },
      ]}
      fetchAll={() => adminGet('/api/admin/carrusel')}
      onCreate={(d) => adminPost('/api/admin/carrusel', d)}
      onUpdate={(id, d) => adminPut(`/api/admin/carrusel/${id}`, d)}
      onDelete={(id) => adminDelete(`/api/admin/carrusel/${id}`)}
    />
  );
}
